"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractUserParameters = exports.extractProductParameters = exports.extractPageParameters = exports.extractOrderParameters = void 0;
/**
 * Nimmt ein Objekt entgegen und filtert dessen Keys nach dem Prefix "order_"
 * und gibt ein Objekt mit nur diesen Keys zurück
 *
 * @category Parameter
 * @param utagData
 */
const extractOrderParameters = (utagData = {}) => {
    return filterByKeyPrefix(utagData, 'order_');
};
exports.extractOrderParameters = extractOrderParameters;
/**
 * Nimmt ein Objekt entgegen und filtert dessen Keys nach dem Prefix "page_"
 * und gibt ein Objekt mit nur diesen Keys zurück
 *
 * @category Parameter
 * @param utagData
 */
const extractPageParameters = (utagData = {}) => {
    return filterByKeyPrefix(utagData, 'page_');
};
exports.extractPageParameters = extractPageParameters;
/**
 * Nimmt ein Objekt entgegen und filtert dessen Keys nach dem Prefix "product_"
 * und gibt ein Objekt mit nur diesen Keys zurück
 *
 * @category Parameter
 * @param utagData
 */
const extractProductParameters = (utagData = {}) => {
    return filterByKeyPrefix(utagData, 'product_');
};
exports.extractProductParameters = extractProductParameters;
/**
 * Nimmt ein Objekt entgegen und filtert dessen Keys nach dem Prefix "user_"
 * und gibt ein Objekt mit nur diesen Keys zurück
 *
 * @category Parameter
 * @param utagData
 */
const extractUserParameters = (utagData = {}) => {
    return filterByKeyPrefix(utagData, 'user_');
};
exports.extractUserParameters = extractUserParameters;
const filterByKeyPrefix = (utagData, keyPrefix) => {
    return Object.fromEntries(Object.entries(utagData).filter(([key]) => key.startsWith(keyPrefix)));
};
